package com.arena_web.ui.sections.header

import com.arena_web.ui.utils.Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val NavHeaderStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .padding(topBottom = 1.cssRem, leftRight = 2.cssRem)
}

val NavLinkStyle = CssStyle {
    base {
        Modifier
            .fontSize(1.cssRem)
            .fontWeight(FontWeight.Medium)
            .padding(0.5.cssRem)
            .cursor(Cursor.Pointer)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("color", Constants.ANIMATION_FAST.ms))
    }
    hover {
        Modifier.opacity(0.7)
    }
}

val IconButtonStyle = CssStyle {
    base {
        Modifier
            .size(40.px)
            .borderRadius(50.percent)
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("background-color", Constants.ANIMATION_FAST.ms),
                Transition.of("transform", Constants.ANIMATION_FAST.ms)
            )
    }
    hover {
        Modifier.scale(1.1)
    }
}

val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }
    to {
        Modifier.translateX(0.percent)
    }
}

enum class SideMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}
